import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaymentService } from '../services/payment.service';
import { LoaderService } from '../services/loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ConfirmSnackbarComponent } from '../confirm-snackbar/confirm-snackbar.component';
import { LogService } from '../services/log.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatExpansionPanel } from '@angular/material/expansion';
import { CompanyDetailsService } from '../services/company-details.service';
import { UserService } from '../services/user.service';


@Component({
	selector: 'app-payment-dialog',
	templateUrl: './payment-dialog.component.html',
	styleUrls: ['./payment-dialog.component.css']
})

export class PaymentDialogComponent implements OnInit {

	constructor(
		public _payment: PaymentService,
		public _load: LoaderService,
		public snackbar: MatSnackBar,
		public dialog: MatDialog,
		private dialogRef: MatDialogRef<PaymentDialogComponent>,
		public bottomSheet: MatBottomSheet,
		public log: LogService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private CompanyDetailsService: CompanyDetailsService,
		private _userService: UserService,
	) { }

	public paymentHistory: any = [];
	public transferHistory: any = [];
	public student_id = "";
	public amount = 0;
	public recipient;
	public message = "";

	public originalID = "";
	public invoiceID;

	public showHistory = false;
	public transferToSelf = false;
	public filterInvoice: any
	public selectedInvoiceId: string | null = null;
	public dynamic_paymentHistory_for_student: any = []
	public selectedPay: any
	public studentAlreadyExists = false
	public allowPaymentTransfer = 0;
	public currentUserMatricNumber
	public currentUserStudentID = 'ABC123';
	closer(): void {
		this.dialogRef.close();
	}
	ngOnInit() {
		// console.log(this.data);
		this.paymentHistory = this.data.paymentHistory;
		this.originalID = this.paymentHistory[0].student_id;


		this.getPaymentTransfers();
		this.fetchCompanyDetails()
		this._userService.getUserData().subscribe(data => {

			this.currentUserMatricNumber = data.matric_no
			this.currentUserStudentID = data.matric_no


		})




	}
	fetchCompanyDetails() {
		this.CompanyDetailsService.getDetails().subscribe(data => {

			this.allowPaymentTransfer = data.payment_transfer_approval
			console.log(this.allowPaymentTransfer);





		}

		)
	}
	getPaymentTransfers() {
		let form = new FormData();
		form.append('student_id', this.originalID);
		this._payment.getPaymentTransfers(form).subscribe(data => {
			this.transferHistory = data;
			console.log(this.transferHistory, 'history');

			this.log
				.addLog({
					action: "Fetch",
					component: "Payment Dialog",
					details: `Fetched Payment Transfers`
				}).subscribe(data => { });
		})
	}


	transferPayment() {
		let form = new FormData();
		form.append("student_id", this.student_id);

		// if (this.originalID == this.student_id) {
		// 	this.message = "You cannot transfer excess payment to yourself";
		// 	return;
		// }
		this._payment.confirmRecipient(form).subscribe(data => {
			// console.log(data);
			if (data.found) {

				this.recipient = data["student"];
				console.log(data);
				this.fetchStudentPaymentHistory(data.student.student_id)
				this.message = "";


				// if (this.recipient.matric_no == this.originalID || this.recipient.student_id == this.originalID) {
				// 	this.message = "You cannot transfer excess payment to yourself";
				// 	this.recipient = "";
				// }
			} else {
				this.message = "Recipient not found, please check again"
			}
		})
	}

	confirmTransfer(pay, panel: MatExpansionPanel) {
		let amount_remaining = Number(pay.amount_remaining);
		let balance = Number(this.amount) + amount_remaining;

		if (balance > 0) {
			this.message = "You cannot transfer beyond the excess that you have here";
			return;
		}

		let sheetRef = this.bottomSheet.open(ConfirmSnackbarComponent, {
			data: { message: "Are you sure you want to initiate this transfer?", button1: 'Yes', button2: 'No' }
		})



		sheetRef.afterDismissed().subscribe(data => {
			if (data) {
				if (data.response) {
					let form = new FormData();
					form.append("sender_id", this.originalID);
					form.append("recipient_id", this.student_id);
					form.append("amount", this.amount.toString());
					form.append("sender_inv_id", pay.invoice_id);
					form.append("recipient_inv_id", this.selectedInvoiceId);

					console.log(this.student_id, 'student_id');

					this._payment.confirmPaymentTransfer(form).subscribe(data => {
						// console.log(data);
						if (data.success) {
							this.message = "";
							this.snackbar.open("Transfer Initiated successfully.", "Dismiss", {
								duration: 3000
							})
							this.log
								.addLog({
									action: "Pay",
									component: "Payment Dialog",
									details: `Made a Transfer to ${this.student_id}`
								}).subscribe(data => { });
							this.student_id = ''
							this.recipient = null;
							this.message = '';
							this.transferToSelf = false;
							this.amount = 0

							panel.close();
							this.ngOnInit();
							this.dialogRef.close('success');
						} else {
							this.message = "Something went wrong, please check again"
						}
					})
				}
			}
		})

	}

	deleteTransfer(transfer) {
		if (transfer.status != 0) {
			return;
		}
		let sheetRef = this.bottomSheet.open(ConfirmSnackbarComponent, {
			data: { message: "Are you sure to delete this transfer?", button1: 'Yes', button2: 'No' }
		})
		sheetRef.afterDismissed().subscribe(data => {
			if (data) {
				if (data.response) {
					let form = new FormData();
					form.append("payment_transfer_id", transfer.payment_transfer_id);
					this._payment.deleteTransfer(form).subscribe(data => {
						if (data.success) {
							this.snackbar.open("Transfer Deleted successfully");
							this.log
								.addLog({
									action: "Delete",
									component: "Payment Dialog",
									details: `Deleted a Transfer with ID - ${transfer.payment_transfer_id}`
								}).subscribe(data => { });
							this.ngOnInit()
						}
					})
				}
			}
		})
	}

	transferAction(transfer, status) {
		let form = new FormData();
		let message = status == 1 ? "Are you sure to accept payment transfer?" : "Are you sure to reject payment transfer?"
		let sheetRef = this.bottomSheet.open(ConfirmSnackbarComponent, {
			data: { message: message, button1: 'Yes', button2: 'No' }
		})
		sheetRef.afterDismissed().subscribe(data => {
			if (data) {
				if (data.response) {

					if (!this.invoiceID) {
						this.snackbar.open("Kindly select an invoice, into which the payment will be transferred into", "Dismiss")
						return;
					}
					form.append("payment_transfer_id", transfer.payment_transfer_id);
					form.append("status", status);
					form.append("sender_inv_id", transfer.sender_inv_id);
					form.append("amount", transfer.amount);
					form.append("recipient_id", transfer.recipient_id);
					form.append("recipient_inv_id", this.invoiceID);
					this._payment.paymentTransferAction(form).subscribe(data => {
						if (data.success) {
							this.snackbar.open(`${data.message}`, "Dismiss");
							this.log
								.addLog({
									action: "Accept",
									component: "Pay Tuition",
									details: `Accepted a Payment Transfer`
								}).subscribe(data => { });
							this.ngOnInit()
							this.dialogRef.close('success');
						}
					})
				}
			}
		})

	}
	onPanelOpened(currentPay: any) {
		this.amount = 0
		this.studentAlreadyExists = true
		if (this.studentAlreadyExists != true) {
			this.student_id = ''

		}
		this.selectedPay = currentPay;
		this.fetchStudentPaymentHistory(this.student_id)


		this.filterInvoice = this.dynamic_paymentHistory_for_student.filter(
			pay => pay.invoice_id !== currentPay.invoice_id
		);



		if (this.filterInvoice.length === 1) {

			this.selectedInvoiceId = this.filterInvoice[0].invoice_id;
		} else {

			this.selectedInvoiceId = null;
		}


	}
	fetchStudentPaymentHistory(student_id: string) {


		const payload = { student_id: student_id };
		this._payment.getStudentPaymentHistory(payload).subscribe(data => {
			console.log(data);
			this.dynamic_paymentHistory_for_student = data;
			this.filterInvoice = this.dynamic_paymentHistory_for_student.filter(
				pay => pay.invoice_id !== this.selectedPay.invoice_id
			);
			if (this.filterInvoice.length === 1) {

				this.selectedInvoiceId = this.filterInvoice[0].invoice_id;
			} else {

				this.selectedInvoiceId = null;
			}

		});
	}

	checkIfSelf() {

		const enteredId = this.student_id?.trim().toLowerCase();
		const matric = this.currentUserMatricNumber?.trim().toLowerCase();
		const studentId = this.currentUserStudentID?.trim().toLowerCase();

		if (enteredId === matric || enteredId === studentId) {
			this.transferToSelf = true
			this.handleSelfTransfer(true);
		}
	}

	onTransferToSelfChange(event: MatCheckboxChange) {
		this.handleSelfTransfer(event.checked);
	}

	handleSelfTransfer(isChecked: boolean) {
		if (isChecked) {
			this.student_id = this.originalID;
			console.log(this.student_id);
			this.transferPayment();
		} else {
			this.student_id = '';
			this.recipient = null;
			this.message = '';
		}
	}


	// confirm(message, callback){
	// 	let sheetRef = this.bottomSheet.open(ConfirmSnackbarComponent,{
	// 		data:{message:message, button1: 'Yes', button2: 'No'}
	// 	 })
	// 	  sheetRef.afterDismissed().subscribe(data => {
	// 		if(data){
	// 		  if(data.response){
	// 			callback()
	// 		  }
	// 		}
	// 	  })
	// }

}
